export default "__VITE_ASSET__B5Bv_0hK__"